import React from 'react'
import { ButtonToolbar, Button, Form, ButtonGroup } from 'react-bootstrap';
import {Modal,
ModalHeader,
ModalBody,
ModalFooter} from 'reactstrap';
import { Scrollbars } from 'react-custom-scrollbars';
import moment from 'moment';
import { apiServices } from '../../services/apiServices';
import Loader from '../../components/loaders/loader';
import swal from "sweetalert";
import Barcode from 'react-barcode';

class CaseDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            show: false,
            clickedOpton: '',
            reason: '',
            chatText: '',
            isChatFetched: false,
            chatTime: '',
            sUUID: '',
            disabled: true,
            currentChat: [],
            showMedia: false,
            mediaURL: '',
            mediaType: '',
        }
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitReason = this.submitReason.bind(this);
        this.chatShow = this.chatShow.bind(this);
        this.chatHide = this.chatHide.bind(this);
        this.handleChatText = this.handleChatText.bind(this);
        this.sendChatText = this.sendChatText.bind(this);

        this.chatEnd = React.createRef();
    }

    handleMediaShow = (mediaURL, mediaType) => {
        this.setState({ showMedia: true, mediaURL, mediaType })
    }

    handleMediaHide = () => {
        this.setState({ showMedia: false })
    }

    chatHide() {
        this.setState({ chatShow: false });
    }

    chatShow() {
        this.setState({ isLoading: true,isChatFetched: false,chatShow: true});
        let oCoummunity = JSON.parse(localStorage.getItem('community')).community,
        sUUID = oCoummunity.uuid,
        oRequest = {
            uuid: sUUID,
            activeYN: 'Y',
            deleteYN: 'N',
            caseID: this.props.caseData.id,
            statusList: ["9", "10", "11", "12", "33", "34"]
        };

        apiServices.loadInboxItem(oRequest).then(response => {
            let currentChat = [];
            currentChat = response[0].caseExtensions;
            this.setState({ isLoading: false, currentChat,isChatFetched: true}, () => this.chatEnd.scrollToBottom());
        }).catch(() =>{
            this.showAlert();
        });
    }

    handleClose() {
        this.setState({ show: false, reason:''});
    }

    handleShow(clickedOpton) {
        this.setState({ show: true, clickedOpton});
    }

    handleChange(e) {
        this.setState({ reason: e.target.value })
    }

    handleChatText(e) {
        if (e.target.value === "") {
            this.setState({ chatText: e.target.value, disabled: true })
        } else {
            this.setState({ chatText: e.target.value, disabled: false })
        }
    }

    sendChatText() {
        let date = new Date();
        date = moment(date).format('MMMM Do YYYY, h:mm:ss a');
        let oRequest = {};
        let caseExtension = {}
        let caseSet = { id: this.props.caseData.id, caseExtensions: [], caseSubsets: [] };
        let social = { comments: this.state.chatText, postedBy: 'ADMINISTRATOR', publisherType: 'ADMINISTRATOR', postedOn: date }
        caseExtension.caseSet = caseSet;
        caseExtension.social = JSON.stringify(social);
        oRequest.caseExtension = caseExtension;

        this.setState({ isLoading: true });
        apiServices.sendChat(oRequest).then(response => {
            let currentChat = [...this.state.currentChat];
            currentChat.push(response.caseExtension);
            if (response.status === "SUCCESS") {
                this.setState({ isLoading: false, currentChat, isChatFetched: true, disabled: true, chatText: '' }, () => this.chatEnd.scrollToBottom());
            }
        })
    }

    submitReason() {
        this.setState({ isLoading: true });
        let caseResolutionSummary = { 'caseResolutionSummary': this.state.reason }
        let caseSet = {
            'id': this.props.caseData.id,
            'operatedBy': null,
            'category': "cat1",
            'support_provided': "",
            'applicant': { 'id': this.props.caseData.applicant.id },
            'extendedDetails': JSON.stringify(caseResolutionSummary)
        }
        if (this.state.clickedOpton === "VALID") {
            caseSet.status = "10";
        }
        if (this.state.clickedOpton === "INVALID") {
            caseSet.status = "11";
        }
        if (this.state.clickedOpton === "DEACTIVATE") {
            caseSet.status = "34";
        }
        if (this.state.clickedOpton === "RESOLVE") {
            caseSet.status = "12";
        }
        if (this.state.clickedOpton === "UNABLE_TO_RESOLVE") {
            caseSet.status = "33";
        }
        let oRequest = {
            "caseExtendedDetails": caseResolutionSummary,
            "updatedBy": "ADMINISTRATOR"
        }
        oRequest.caseSet = caseSet;
        // console.log(oRequest);

        apiServices.resolve(oRequest).then(response => {
            // console.log(response);
            if (response.status === "SUCCESS") {
                if (this.props.loadInbox) {
                    this.setState({ show: false, isLoading: false }, () => this.props.loadInbox());
                } else {
                    this.setState({ show: false, isLoading: false }, () => window.location.reload());
                }
            }
        })
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.caseData.id !== prevProps.caseData.id) {
            this.setState({ currentChat: [] });
        }
    }

    showAlert = () =>{
        this.setState({isLoading:false});
        swal({
            title: "Error in fetching case details!!!",
            text: "Contact you Administrator.",
            icon: "error",
            button: "OK"
        });
    }

    render() {
        let date = moment(this.props.caseData.createdAt).format("MMM Do YYYY, h:mm:ss a");
        let days = moment(this.props.caseData.createdAt).format("YYYYMMDD , h:mm:ss a");
        days = moment(days, 'YYYYMMDD, h:mm:ss a').fromNow();
        const data = this.props.caseData;
        // console.log("data",data);
        let questions = null,
            answers = null,
            chatHistory = null,
            mediaPhoto = true,
            mediaVideo = true,
            mediaAudio = true,
            mediaGallaryPhoto = true,
            mediaBarcode = true,
            photoId = null,
            imageURL = null,
            videoURL = null,
            audioURL = null,
            barcode = null;
        try {
            questions = JSON.parse(data.communityPreferencesByCaseType.jsonValue);
            // console.log("questions", questions);

            answers = data.caseExtensions!==null ? data.caseExtensions.filter(chatData => !chatData.hasOwnProperty('social')) : [];

            // console.log(answers);
            if(answers.length > 0){
                mediaPhoto = answers[0].photoId !== "" ? false : true;
                mediaVideo = answers[0].videoURL !== "" ? false : true;
                mediaAudio = answers[0].audioURL !== "" ? false : true;
                mediaGallaryPhoto = answers[0].imageURL !== "" ? false : true;
                mediaBarcode = answers[0].barCode !== "" ? false : true;

                photoId = answers[0].photoId;
                imageURL = answers[0].imageURL;
                videoURL = answers[0].videoURL.split('",')[0];
                audioURL = answers[0].audioURL;
                barcode = answers[0].barCode;

                answers = JSON.parse(answers[0].jsonValue);
                chatHistory = data.caseExtensions.filter(chatData => chatData.hasOwnProperty('social'));
            } 
            // console.log("answers", answers);

        } catch (e) {
            // console.log("Error in fetching CaseDetails");
            swal({
                title: "Error in fetching case details!!!",
                text: "Contact you Administrator.",
                icon: "error",
                button: "OK"
            })
        }

        const showActionButtons = this.props.showActionButtons==="false" ? false : true;
        const discussionBoard = this.props.discussionBoard==="false" ? false : true;
        const showAttachmentButtons = this.props.showAttachmentButtons==="false" ? false : true;

        return (
            <React.Fragment>
                <Loader isLoading={this.state.isLoading}/>
                {data ?
                            <React.Fragment>
                                { showActionButtons && <div className="toolbar pb-3 border-bottom">
                                    { data.status === 9 &&
                                        <ButtonToolbar>
                                            <Button variant="outline-dark" className="flex-grow-1 mx-1 mb-1" onClick={() => this.handleShow("VALID")} ><i className="fa fa-check"></i> VALID</Button>
                                            <Button variant="outline-dark" className="flex-grow-1 mx-1 mb-1" onClick={() => this.handleShow("INVALID")} ><i className="fa fa-times"></i> INVALID</Button>
                                            <Button variant="outline-dark" className="flex-grow-1 mx-1 mb-1" onClick={() => this.handleShow("DEACTIVATE")} ><i className="fa fa-ban"></i> DEACTIVATE</Button>
                                            <Button variant="outline-dark" className="flex-grow-1 mx-1 mb-1 d-none" onClick={() => this.handleShow("NEARME")} ><i className="fa fa-compass"></i> NEARME</Button>
                                            <a href={`https://uat.imonitorplus.com/service/api/imonitor/report/${this.props.sUUID}/${data.id}/exportCaseDetails`} target="_blank" rel="noopener noreferrer" className="flex-grow-1 mx-1">
                                                <Button variant="outline-dark" className="w-100 mb-1"><i className="fa fa-download"></i> DOWNLOAD
                                                </Button>
                                            </a>
                                            <a href={`https://web.imonitorplus.com/streetview.html?lat=${data.latitude}&lng=${data.longitude}`} target="_blank" rel="noopener noreferrer" className="flex-grow-1 mx-1">
                                                <Button variant="outline-dark" className="w-100 mb-1"><i className="fa fa-location-arrow"></i> LOCATION
                                                </Button>
                                            </a>
                                        </ButtonToolbar>
                                    }
                                    {data.status === 10 &&
                                        <ButtonToolbar>
                                            <Button variant="outline-dark" className="flex-grow-1 mx-1 mb-1" onClick={() => this.handleShow("RESOLVE")} ><i className="fa fa-check"></i> RESOLVE</Button>
                                            <Button variant="outline-dark" className="flex-grow-1 mx-1 mb-1" onClick={() => this.handleShow("UNABLE_TO_RESOLVE")} ><i className="fa fa-times"></i> UNABLE TO RESOLVE</Button>
                                            <Button variant="outline-dark" className="flex-grow-1 mx-1 mb-1 d-none" onClick={() => this.handleShow("NEARME")} ><i className="fa fa-compass"></i> NEARME</Button>
                                            <a href={`https://uat.imonitorplus.com/service/api/imonitor/report/${this.props.sUUID}/${data.id}/exportCaseDetails`} target="_blank" rel="noopener noreferrer" className="flex-grow-1 mx-1">
                                                <Button variant="outline-dark" className="w-100 mb-1"><i className="fa fa-download"></i> DOWNLOAD
                                                </Button>
                                            </a>
                                            <a href={`https://web.imonitorplus.com/streetview.html?lat=${data.latitude}&lng=${data.longitude}`} target="_blank" rel="noopener noreferrer" className="flex-grow-1 mx-1">
                                                <Button variant="outline-dark" className="w-100 mb-1"><i className="fa fa-location-arrow"></i> LOCATION
                                                </Button>
                                            </a>
                                        </ButtonToolbar>
                                    }
                                    {data.status === 12 &&
                                        <ButtonToolbar>
                                            <Button variant="outline-dark" className="flex-grow-1 mx-1 mb-1 d-none" onClick={() => this.handleShow("NEARME")} ><i className="fa fa-compass"></i> NEARME</Button>
                                            <a href={`https://uat.imonitorplus.com/service/api/imonitor/report/${this.props.sUUID}/${data.id}/exportCaseDetails`} target="_blank" rel="noopener noreferrer" className="flex-grow-1 mx-1">
                                                <Button variant="outline-dark" className="w-100 mb-1"><i className="fa fa-download"></i> DOWNLOAD
                                                </Button>
                                            </a>
                                            <a href={`https://web.imonitorplus.com/streetview.html?lat=${data.latitude}&lng=${data.longitude}`} target="_blank" rel="noopener noreferrer" className="flex-grow-1 mx-1">
                                                <Button variant="outline-dark" className="w-100 mb-1"><i className="fa fa-location-arrow"></i> LOCATION
                                                </Button>
                                            </a>
                                        </ButtonToolbar>
                                    }
                                    {data.status === 11 &&
                                        <ButtonToolbar>
                                            <Button variant="outline-dark" className="flex-grow-1 mx-1 mb-1 d-none" onClick={() => this.handleShow("NEARME")} ><i className="fa fa-compass"></i> NEARME</Button>
                                            <a href={`https://uat.imonitorplus.com/service/api/imonitor/report/${this.props.sUUID}/${data.id}/exportCaseDetails`} target="_blank" rel="noopener noreferrer" className="flex-grow-1 mx-1">
                                                <Button variant="outline-dark" className="w-100 mb-1"><i className="fa fa-download"></i> DOWNLOAD
                                                </Button>
                                            </a>
                                            <a href={`https://web.imonitorplus.com/streetview.html?lat=${data.latitude}&lng=${data.longitude}`} target="_blank" rel="noopener noreferrer" className="flex-grow-1 mx-1">
                                                <Button variant="outline-dark" className="w-100 mb-1"><i className="fa fa-location-arrow"></i> LOCATION
                                                </Button>
                                            </a>
                                        </ButtonToolbar>
                                    }
                                </div>
                                }
                                <Modal isOpen={this.state.show} toggle={this.handleClose} onClosed={this.props.closeAll ? this.handleClose : undefined}>
                                        <ModalHeader toggle={this.handleClose}>
                                            {this.state.clickedOpton}
                                        </ModalHeader>
                                        <ModalBody>
                                            <Form>
                                                <Form.Group controlId="reason">
                                                    <Form.Label>Reason</Form.Label>
                                                    <Form.Control as="textarea" rows="3" onChange={this.handleChange}/>
                                                </Form.Group>
                                            </Form>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button variant="primary" onClick={this.submitReason} disabled={this.state.reason==="" && true}>
                                                Ok
                                            </Button>
                                            <Button variant="secondary" onClick={this.handleClose}>
                                                Cancel
                                            </Button>
                                        </ModalFooter>
                                    </Modal>
                                <div className="pt-3">
                                    <div className="pb-2">
                                        {!this.props.isPopup && <span className="from">
                                            <strong>Case ID :</strong> #{data.id}
                                        </span>
                                        }
                                        <span className="float-right">
                                            {data.status===9 && <Button variant="light" disabled>Open</Button>}
                                            {data.status===10 && <Button variant="light" disabled>Approved</Button>}
                                            {data.status===11 && <Button variant="light" disabled>Declined</Button>}
                                            {data.status===12 && <Button variant="light" disabled>Resolved</Button>}
                                        </span>
                                    </div>
                                    <div className="pb-2">
                                        <strong>Address :</strong> {data.address}
                                    </div>
                                    <div className="pb-2">
                                        <strong>Applicant ID :</strong> {data.applicant.id}
                                    </div>
                                    <div className="pb-2">
                                        <strong>Date :</strong> {date}, {days}
                                    </div>
                                    {showAttachmentButtons && <div className="d-flex flex-column py-4">
                                        <ButtonGroup>
                                            {mediaPhoto ? <Button disabled={mediaPhoto} className="mr-1"><span className="fa fa-camera"></span></Button>
                                            :
                                            <Button onClick={()=>this.handleMediaShow(photoId,"Camera Image")} className="mr-1"><span className="fa fa-camera"></span></Button>
                                            }
                                            {mediaGallaryPhoto ? <Button disabled={mediaGallaryPhoto} className="mx-1"><span className="fa fa-image"></span></Button>
                                            :
                                            <Button onClick={()=>this.handleMediaShow(imageURL,"Gallary Image")} className="mx-1"><span className="fa fa-image"></span></Button>
                                            }
                                            {mediaVideo ? <Button disabled={mediaVideo} className="mx-1"><span className="fa fa-play-circle"></span></Button>
                                            :
                                            <Button onClick={()=>this.handleMediaShow(videoURL,"Video")} className="mx-1"><span className="fa fa-play-circle"></span></Button>
                                            }
                                            {mediaAudio ? <Button disabled={mediaAudio} className="mx-1"><span className="fa fa-headphones"></span></Button>
                                            :
                                            <Button onClick={()=>this.handleMediaShow(audioURL,"Audio")} className="mx-1"><span className="fa fa-headphones"></span></Button>
                                            }
                                            {mediaBarcode ? <Button disabled={mediaBarcode} className="ml-1"><span className="fa fa-barcode"></span></Button>
                                            :
                                            <Button onClick={()=>this.handleMediaShow(barcode,"Barcode")} className="ml-1"><span className="fa fa-barcode"></span></Button>
                                            }
                                        </ButtonGroup>
                                        <Modal 
                                            isOpen={this.state.showMedia} 
                                            toggle={this.handleMediaHide}
                                            onClosed={this.props.closeAll ? this.handleMediaHide : undefined} 
                                        >
                                            <ModalHeader toggle={this.handleMediaHide}>
                                                {this.state.mediaType}
                                            </ModalHeader>
                                            <ModalBody className="text-center">
                                                {this.state.mediaType ==="Camera Image" && 
                                                    <img src={this.state.mediaURL} alt="camera" height="300"/>
                                                }
                                                {this.state.mediaType ==="Gallary Image" && 
                                                    <img src={this.state.mediaURL} alt="gallary" height="300"/>
                                                }
                                                {this.state.mediaType ==="Video" && 
                                                    <video width="320" height="240" controls autoPlay>
                                                        <source src={this.state.mediaURL} type="video/mp4" />
                                                        <source src={this.state.mediaURL} type="video/webm" />
                                                        <source src={this.state.mediaURL} type="video/ogg" />
                                                        <source src={this.state.mediaURL} type="video/flv" />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                }
                                                {this.state.mediaType ==="Audio" && 
                                                    <audio controls autoPlay>
                                                        <source src={this.state.mediaURL} type="audio/mpeg" />
                                                        <source src={this.state.mediaURL} type="audio/amr" />
                                                        <source src={this.state.mediaURL} type="audio/ogg" />
                                                        <source src={this.state.mediaURL} type="audio/wav" />
                                                        Your browser does not support the audio element.
                                                    </audio>
                                                }
                                                {this.state.mediaType === "Barcode" && 
                                                    <Barcode value={this.state.mediaURL} />
                                                }
                                            </ModalBody>
                                        </Modal>
                                    </div>
                                    }
                                    {questions && questions.length > 0 &&
                                    <div className="question border mt-4 p-3">
                                            <Form>
                                            {questions.map((que,index) =>{
                                                // console.log(que);
                                                // console.log(que.data.en_US.type.value);
                                                let question = que.data.en_US;
                                                // console.log(question);

                                                    // console.log(answers[question.name]);
                                                    let answer = "";
                                                    if(answers!==null){
                                                        for (const key of Object.keys(answers)) {
                                                            if(key === question.name){
                                                                answer = answers[key] 
                                                            }
                                                        }
                                                    }
                                                    // console.log(answer);

                                                switch(question.type.value){
                                                    case "Checkbox":
                                                        return <Form.Group controlId="checkbox" key={index}>
                                                        <Form.Label><strong>{question.name}</strong></Form.Label>
                                                        {question.nominal.map((checkboxOption,index) =>{
                                                            let checked = false;
                                                            answer.length > 0 && answer.map((ans)=> checkboxOption===ans ? checked = true : "")
                                                            return  <div key={checkboxOption} className="mb-2">
                                                                        <Form.Check
                                                                            disabled 
                                                                            type="checkbox"
                                                                            label={checkboxOption}
                                                                            checked={checked}
                                                                        />
                                                                    </div>
                                                        })}
                                                    </Form.Group>
                                                    case "Radio":
                                                        return <Form.Group controlId="radio" key={index}>
                                                        <Form.Label><strong>{question.name}</strong></Form.Label>
                                                        {question.nominal.map((radioOption,index) =>{
                                                            return  <div key={radioOption} className="mb-2">
                                                                        <Form.Check
                                                                            disabled 
                                                                            type="radio"
                                                                            label={radioOption}
                                                                            checked={radioOption===answer}
                                                                        />
                                                                    </div>
                                                        })}
                                                    </Form.Group>
                                                    case "Dropdown":
                                                        return <Form.Group controlId="dropdown" key={index}>
                                                        <Form.Label><strong>{question.name}</strong></Form.Label>
                                                        <Form.Control as="select" defaultValue={answer} disabled style={{width:'50%'}}>
                                                            <option>Select</option>
                                                            {question.nominal.map((dropdownOption,index) =>{
                                                                return <option key={index}>{dropdownOption}</option>
                                                            })}
                                                        </Form.Control>
                                                    </Form.Group>
                                                    case "Text":
                                                        return <Form.Group controlId="textarea" key={index}>
                                                        <Form.Label><strong>{question.name}</strong></Form.Label>
                                                        <Form.Control as="textarea" rows="1" defaultValue={answer} readOnly style={{width:'50%'}}/>
                                                    </Form.Group>
                                                    default:
                                                    return <Form.Group controlId="textInputs" key={index}>
                                                            <Form.Label><strong>{question.name}</strong></Form.Label>
                                                            <Form.Control type="text" defaultValue={answer} readOnly plaintext className="text-muted" />
                                                        </Form.Group>
                                                }
                                            })
                                            }
                                            </Form>
                                    </div>
                                    }
                                    {this.props.isPopup && (data.status === 9 || data.status === 10) ?<div className="py-3">
                                            <Button variant="outline-dark" className="w-100" onClick={() => this.handleShow("RESOLVE")} ><i className="fa fa-check"></i> RESOLVE</Button>
                                        </div>
                                        : null
                                    }
                                </div>
                                { discussionBoard && 
                                    <React.Fragment>
                                        {data.id && <Button variant="primary" className="floating_button" onClick={this.chatShow}><i className="fa fa-comments"></i></Button>}
                                        <Modal 
                                            isOpen={this.state.chatShow} 
                                            toggle={this.chatHide} 
                                            centered
                                        >
                                            <ModalHeader toggle={this.chatHide}>
                                                Discussion Board
                                            </ModalHeader>
                                            <ModalBody className="inbox_chat" >
                                                <Scrollbars style={{ width: '100%', height: 300 }} ref={(el) => { this.chatEnd = el; }}>
                                                    { chatHistory &&
                                                        chatHistory.length > 0 && 
                                                        chatHistory.map((chat,index)=>{
                                                            let chatData = JSON.parse(chat.social);
                                                            return chatData.postedBy === "ADMINISTRATOR" ?
                                                                <div className="response_chat pb-3" key={chat.id}>
                                                                    <div className="dateTime"><small>{chatData.postedOn ? chatData.postedOn : ""}</small></div>
                                                                    <div className="chat_content">
                                                                        <div className="text">{chatData.comments ? chatData.comments : ""}</div>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="request_chat pb-3" key={chat.id}>
                                                                    <div className="dateTime"><small>{chatData.postedOn ? chatData.postedOn : ""}</small></div>
                                                                    <div className="chat_content">
                                                                        <div className="text">{chatData.comments ? chatData.comments : ""}</div>
                                                                    </div>
                                                                </div>
                                                        })
                                                    }
                                                    {this.state.isChatFetched && 
                                                        this.state.currentChat.length > 0 &&
                                                        this.state.currentChat.map(chat=>{
                                                            if(!chat.social){
                                                                return null;
                                                            }
                                                            let chatData = JSON.parse(chat.social);
                                                            return  <div className="response_chat pb-3" key={chat.id}>
                                                                <div className="dateTime"><small>{chatData.postedOn ? chatData.postedOn : ""}</small></div>
                                                                <div className="chat_content">
                                                                    <div className="text">{chatData.comments ? chatData.comments : ""}</div>
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </Scrollbars>
                                            </ModalBody>
                                            <ModalFooter>
                                                <Form.Group controlId="formChatText" className="mb-0 w-100">
                                                    <Form.Control type="text" placeholder="Enter your message here" value={this.state.chatText} onChange={this.handleChatText} />
                                                </Form.Group>
                                                <Button variant="primary" onClick={this.sendChatText} disabled={this.state.disabled}>
                                                    Send
                                                </Button>
                                            </ModalFooter>
                                        </Modal>
                                    </React.Fragment>
                                }
                        </React.Fragment>
                :
                <div className="text-center">No Data</div>
                }
            </React.Fragment>
        )
    }
}

export default CaseDetails;